import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchQuotations(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/quotations/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchQuotation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/quotations/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editQuotation(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/quotations", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteQuotation(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/quotations", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteQuotationSalary(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/quotations/salary", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteQuotationCost(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/quotations/cost", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateQuotationDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/quotations/document", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    getCustomerAddresses(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/customers/${id}/addresses`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 獲取下一個報價單編號
    getNextQuotationNumber(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/quotations/next-number")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // 驗證報價單編號唯一性
    validateQuotationNumber(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/quotations/validate-number", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }
  }
};
